<template>
    <tr>
        <td>
            <span>ДКП № </span><span class="font-weight-bold">{{deal.document_number}}</span>
            <span class="d-block small text-muted">от {{deal.document_date}}</span>
            <span class="mt-3 badge badge-light text-dark">{{deal.in_credit ? 'В кредит' : 'Наличные'}}</span>
            <span v-if="deal.is_trade_in" class="badge badge-light text-dark">Trade-In</span>
            <span v-if="deal.comment && deal.comment.length" class="small text-muted d-block mt-1"><i class="far fa-comment small text-muted"></i> {{ deal.comment }}</span>
        </td>
        <td>
            <div class="">
                <div class="small text-muted">статус</div>
                <div class="">{{ status_label }}</div>
            </div>
            <div class="mt-1">
                <div class="small text-muted">сумма</div>
                <div class="">{{ (deal.sale_amount / 100) | formatNumber }} руб</div>
            </div>
        </td>
        <td>
            <div class="" v-loading="isLoadingAuto">
                <div class="small text-muted">автомобиль</div>
                <template v-if="sale_car">
                    <div class="">{{ sale_car_title }}</div>
                    <div class="small cursor-pointer" @click="showEditCar(sale_car.id)"><span class="text-success font-weight-bold mr-1">VIN</span><span class="text-muted">{{ sale_car.pts_vin }}</span></div>
                </template>
            </div>
            <div class="mt-1" v-if="deal.in_credit">
                <span class="text-muted small mr-1 text-nowrap">кредит:</span><span class="text-nowrap">{{(deal.credit_amount / 100) | formatNumber}} руб</span><span class="text-muted small ml-1 mr-1 text-nowrap">взнос:</span><span>{{(deal.sale_initial_payment / 100) | formatNumber}} руб</span>
            </div>
            <div v-if="deal.is_trade_in" class="mt-2" v-loading="isLoadingTradeInAuto">
                <div class="small text-muted">Trade-In</div>
                <template v-if="trade_in_car">
                    <div class="">{{ trade_in_car_title }}</div>
                    <div class="small cursor-pointer" @click="showEditCar(trade_in_car.id)"><span class="text-success font-weight-bold mr-1">VIN</span><span class="text-muted">{{ trade_in_car.pts_vin }}</span></div>
                </template>
            </div>
        </td>
        <td>
            <a v-if="$hasPermissionInterface('deal.documents_generate')" class="btn btn-light" @click="modal_documents = true">Документы</a>
        </td>
        <td>
            <div class="dropdown show text-right">
                <a href="#" data-toggle="dropdown" data-display="static" class="text-black-50 px-2"><i class="fas fa-ellipsis-v"></i></a>

                <div class="dropdown-menu dropdown-menu-right">
                    <a v-if="$hasPermission('deals.update') || $hasPermissionInterface('deal.form.show')" class="dropdown-item" @click="form_state = true">Редактировать</a>
                </div>
            </div>
        </td>
        <el-dialog width="900px" :visible.sync="form_state" :title="'Сделка ' + deal.document_number" :append-to-body="true">
            <DealForm v-if="form_state" :type="deal.type" :mode="'edit'" :request_id="deal.request_id" :deal="deal" @updated="form_state = false" :disabled_car="isDisabledCar" :link_request="showLinkRequest" :allowed_create_car="isAllowedCreateCar"/>
        </el-dialog>
        <el-dialog :visible.sync="modal_documents" :title="'Документы'" :append-to-body="true" width="450px">
            <DocumentList v-if="modal_documents" :deal_id="deal.id" />
        </el-dialog>
        <el-dialog title="Карточка автомобиля" :visible.sync="car_form_state" width="800px" top="5vh" v-loading="car_form_loading" :append-to-body="true" @close="handlerCloseCar">
            <CarForm v-if="car_form_state && !car_form_loading" :mode="'edit'" :obj="car_form_obj"/>
        </el-dialog>
    </tr>
</template>

<script>
import DealForm from "./DealForm";
import DocumentList from "../documents/DocumentList";
import CarForm from "../cars/CarForm.vue";
export default {
    name: "DealListItem",
    components: {CarForm, DocumentList, DealForm},
    props: {
        deal: {
            type: Object,
            required: true,
        },
        source: {
            type: String,
            required: true,
            validator: function (value) {
                return ['request', 'car'].indexOf(value) !== -1
            }
        },
    },
    data: () => ({
        form_state: false,
        modal_documents: false,
        sale_car: null,
        trade_in_car: null,
        isLoadingAuto: false,
        isLoadingTradeInAuto: false,

        car_form_state: false,
        car_form_loading: false,
        car_form_obj: null,
    }),
    mounted() {
        this.fetchCars();
    },
    watch: {
        deal() {
            this.fetchCars();
        },
    },
    computed: {
        type_label() {
            return 'Продажа';
        },
        status_label() {
            switch (this.deal.status) {
                case -1: return "Отменена";
                case 0: return "Открыта";
                case 1: return "Закрыта";
            }
        },
        sale_car_title() {
            return this.sale_car ? this.getCarTitle(this.sale_car) : "";
        },
        trade_in_car_title() {
            return this.trade_in_car ? this.getCarTitle(this.trade_in_car) : "";
        },
        isDisabledCar() {
            return this.source === 'car';
        },
        showLinkRequest() {
            return this.source === 'car';
        },
        isAllowedCreateCar() {
            return this.source !== 'car';
        },
    },
    methods: {
        getCarTitle(car) {
            return [car.brand_name, car.model_name, car.generation_name].join(' ') + ', ' + car.pts_year + 'г';
        },
        fetchCars() {
            let self = this;
            if (this.deal && this.deal.sale_car_id) {
                this.isLoadingAuto = true;
                axios.get('/api/cars/' + this.deal.sale_car_id)
                    .then(r => {
                        self.sale_car = r.data;
                        self.isLoadingAuto = false;
                    })
            }
            if (this.deal && this.deal.trade_in_car_id) {
                this.isLoadingTradeInAuto = true;
                axios.get('/api/cars/' + this.deal.trade_in_car_id)
                    .then(r => {
                        self.trade_in_car = r.data;
                        self.isLoadingTradeInAuto = false;
                    })
            }
        },

        showEditCar(id) {
            let self = this;
            this.car_form_state = true;
            this.car_form_loading = true;
            axios.get('/api/cars/' + id)
                .then(response => {
                    self.car_form_obj = response.data;
                    self.car_form_loading = false;
                })
        },
        handlerCloseCar() {
            this.car_form_state = false;
            this.car_form_loading = false;
            this.car_form_obj = null;
        }
    }
}
</script>

<style scoped>

</style>
